import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.config.productionTip = false

const VueApp = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

export default VueApp
